import { render, staticRenderFns } from "./HelpVideoList.vue?vue&type=template&id=8defc8c4&scoped=true"
import script from "./HelpVideoList.vue?vue&type=script&lang=js"
export * from "./HelpVideoList.vue?vue&type=script&lang=js"
import style0 from "./HelpVideoList.vue?vue&type=style&index=0&id=8defc8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defc8c4",
  null
  
)

export default component.exports